"use client";

import { usePathname } from "next/navigation";
import Footer from "@/components/ui/Footer";
import { Dictionary } from "@/app/[lang]/dictonaries";

export default function FooterWrapper({dict}: {dict: Dictionary}) {
    const pathname = usePathname();

    if (pathname === "/dashboard" || pathname === "/dashboard-no-order" || pathname.includes("/meal-plan") || pathname.includes("/single-meals") || pathname.includes(("/sorting"))) {
        return null;
    }

    return <Footer dict={dict} />;
}